import React from "react";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";

import AddressComponent from "../common/contacts/Address";
import SubContactBasicDataComponent from "../common/contacts/SubContactBasicData";
import SubcontactSuscription from "../common/contacts/SubcontactSuscription";
import CommentsComponent from "../common/Comments";
import MediaComponent from "../common/Media";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import api from "../common/api";

import LinearProgress from "@material-ui/core/LinearProgress";
import Backdrop from "@material-ui/core/Backdrop";
import MobileData from "../common/contacts/MobileData";

class SubContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      basic_data: {
        firstname: "",
        lastname: "",
        subcontact_type_id: "",
        parent_contact_id: "",
        notes: "",
        phone: "",
        mobile: "",
        email: "",
        document_number: "",
        document_type_id: "",
        license_number: "",
        license_due_date: "",
        code: "",
        contact_relation: "",
        client_structure_id: ""
      },
      address_data: [
        {
          id: "",
          code: "",
          type: "",
          floor: "",
          departament: "",
          others: "",
          street: ""
        }
      ],
      user: {},
      places: [],
      cuitExists: false,
      emailExists: false,
      receive_invoice: false,
      client_structures: [],
      document_types: [],
      subcontact_types: [],
      address_types: [],
      suscription_types: [],
      suscription_data: [{}],
      items_to_delete: { suscription: [] },
      contact: {
        id: "",
        business_name: "",
        client: { business_name: "", structure: [] },
        provider: { business_name: "" }
      },
      comment: "",
      errors: false,
      errorMessage: "",
      loading: true,
      dialogOpen: false,
      action: "new",
      dialogOpen: false,
      backdrop: false
    };

    this.handleDeleteAddress = this.handleDeleteAddress.bind(this);
    this.handleNewComment = this.handleNewComment.bind(this);
    this.handleCommentSubmit = this.handleCommentSubmit.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  async componentDidMount() {
    var params = this.getParams();
    var contact_id = params.contact_id;
    this.setState({ parent_contact_id: contact_id });
    var subcontact_id = params.id;
    var view = params.view;
    if (subcontact_id !== undefined) {
      var action = view === "1" ? "view" : "edit";
      await this.setSubContact(subcontact_id);
      await this.getContact(this.state.parent_contact_id);
      this.setState({ subcontact_id: subcontact_id });
      this.setState({ action: action });
      this.setState({ disabled: view });
      await this.getApiData();
    } else {
      await this.getContact(contact_id);
      this.setState({ action: "new", loading: false });
      await this.getApiData();
    }
  }

  getParams() {
    return this.props.match.params;
  }

  async getContact(contact_id) {
    const token = localStorage.getItem("userToken");

    var results = await axios
      .all([
        axios.get(api.contacts().get(contact_id), {
          headers: { Authorization: `Bearer ${token}` }
        })
      ])
      .then(
        axios.spread((...responses) => {
          const contact = responses[0].data;
          this.setState({
            contact,
            parent_contact_id: contact.id
          });
        })
      );
  }

  async getUserByEmail(email) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.users().get(0, email), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        return res.data[0];
      })
      .catch(err => {
        console.log(err);
      });
  }

  async setSubContact(id) {
    var subcontact_data = await this.getSubContact(id);
    this.setState({ subcontact_data: subcontact_data });
    if (subcontact_data.id) {
      var user = await this.getUserByEmail(subcontact_data.contact.email);
      this.setState({ user: user });
    }
    var address_data = [];
    var places = [];
    if (subcontact_data.contact && subcontact_data.contact.address.length > 0) {
      subcontact_data.contact.address.map((val, idx) => {
        var street_number = "";
        if (JSON.parse(val.data).address_components[0].long_name === "S/N") {
          street_number = val.number;
        }

        var place = [];
        address_data.push({
          id: val.id,
          code: val.code,
          type: val.address_type_id,
          street_number: street_number,
          street: val.street,
          number: val.number,
          floor: val.floor ? val.floor : "",
          departament: val.departament ? val.departament : "",
          others: val.others ? val.others : "",
          postal_code: val.postal_code
        });
        place.push(JSON.parse(val.data));
        places.push(place);
      });
    }
    if (subcontact_data.suscriptions.length === 0)
      subcontact_data.suscriptions = [{}];
    this.setState({
      basic_data: {
        hansa_code: subcontact_data.contact.hansa_code,
        firstname: subcontact_data.firstname,
        lastname: subcontact_data.lastname,
        subcontact_type_id: subcontact_data.subcontact_type_id,
        email: subcontact_data.contact.email,
        phone: subcontact_data.contact.phone,
        mobile: subcontact_data.contact.mobile,
        document_type_id: subcontact_data.contact.document_type,
        document_number: subcontact_data.contact.document_number,
        license_number: subcontact_data.license_number
          ? subcontact_data.license_number
          : "",
        license_due_date: subcontact_data.license_due_date
          ? subcontact_data.license_due_date
          : "",
        code: subcontact_data.code ? subcontact_data.code : "",
        contact_relation: subcontact_data.contact_relation
          ? subcontact_data.contact_relation
          : "",
        client_structure_id: subcontact_data.client_structure_id,
        receive_invoice: subcontact_data.receive_invoice === 1 ? true : false,
        user_id: user ? user.id : ""
      },
      address_data: address_data,
      suscription_data: subcontact_data.suscriptions,
      parent_contact_id: subcontact_data.parent_contact_id,
      places: places,
      comments: subcontact_data.comments,
      media: subcontact_data.media,
      contact_id: subcontact_data.contact_id,
      loading: false
    });
  }

  getSubContact(id) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.subcontacts().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }
  getApi(url, params) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        res.data = Object.values(res.data);
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getApiData() {
    const token = localStorage.getItem("userToken");
    var subcontact_url = api.clients_subcontact_types;
    if (this.state.contact.provider !== null) {
      subcontact_url = api.providers_subcontact_types;
    }
    var results = await axios
      .all([
        axios.get(api.address_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(subcontact_url, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.document_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.suscription_types, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ])
      .then(
        axios.spread((...responses) => {
          const address_types = responses[0].data;
          const subcontact_types = responses[1].data;
          const document_types = responses[2].data;
          const suscription_types = responses[3].data;
          this.setState({
            address_types,
            subcontact_types,
            document_types,
            suscription_types
          });
        })
      );
  }

  handlePlaceSearch = newPlaces => {
    var address_data = this.state.address_data;
    var code = address_data.length.toString().padStart(4, "0");
    address_data[address_data.length - 1].code = code;
    address_data.push({ id: "", code: "", type: "" });
    this.setState({ places: newPlaces, address_data: address_data });
  };

  removeItem = idx => () => {
    var address_data = this.state.address_data;
    if (address_data[idx]["id"] === "") {
      address_data = address_data.filter((s, sidx) => idx !== sidx);
      if (address_data.length === 0) {
        address_data.push({ code: "", type: "", id: "" });
      }
      var places = this.state.places;
      places = places.filter((s, sidx) => idx !== sidx);
      this.setState({ address_data: address_data, places: places });
    } else {
      this.setState({
        feature_deleted: false,
        dialogOpen: true,
        message: "Esta a punto de eliminar el domicilio. ¿Está seguro?",
        address_id: address_data[idx]["id"],
        delete_address: true,
        errors: false,
        delete_feature: false
      });
    }
  };

  addNewItem = mod => {
    var state = this.state;
    state.suscription_data.push({});
    this.setState({ state });
  };

  filterItem = (mod, id) => {
    var state = this.state;
    state.items_to_delete.suscription.push(state.suscription_data[id]);
    state.suscription_data = state.suscription_data.filter(
      (s, sidx) => id !== sidx
    );
    this.setState({ state });
  };

  handleDeleteAddress() {
    var address_data = this.state.address_data;
    var places = this.state.places;
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .delete(api.contacts().deleteAddress(this.state.address_id), {
        params: { "address[id]": this.state.address_id },
        headers: { Authorization: `Bearer ${token}` }
      })

      .then(response => {
        self.setState({ errors: false });
        self.setState({ delete_address: false });
        address_data.map((val, idx) => {
          if (val.id === this.state.address_id) {
            address_data = address_data.filter((s, sidx) => idx !== sidx);
            places = places.filter((s, sidx) => idx !== sidx);
          }
        });
        self.setState({
          address_id: "",
          address_data: address_data,
          places: places
        });
        self.setState({ dialogOpen: true, feature_deleted: true });
        self.setState({ message: "Domicilio eliminado con éxito!" });
      })
      .catch(function(error) {
        self.setState({ errors: true });
        self.setState({ delete_address: false });
        self.setState({
          message:
            "El domicilio es el único del contacto. Ingrese uno nuevo para poder eliminar."
        });
        self.setState({ dialogOpen: true });
        self.setState({ address_id: "" });
      });
  }
  handleChange = (event, mod) => {
    var key = event.target.name;
    var val = event.target.value;
    switch (mod) {
      case "basic_data":
        var basic_data = this.state.basic_data;
        if (key === "receive_invoice") {
          val = event.target.checked;
        }
        basic_data[key] = val;
        this.setState({ basic_data: basic_data });
        return "";

      case "address_data":
        var address_data = this.state.address_data;
        var data = key.split(".");
        if (data[0] === "code") {
          address_data[data[1]].code = val;
        } else if (data[0] === "street_number") {
          address_data[data[1]].street_number = val;
        } else if (data[0] === "postal_code") {
          address_data[data[1]].postal_code = val;
        } else if (data[0] === "type") {
          address_data[data[1]].type = val;
        } else if (data[0] === "floor") {
          address_data[data[1]].floor = val;
        } else if (data[0] === "departament") {
          address_data[data[1]].departament = val;
        } else if (data[0] === "others") {
          address_data[data[1]].others = val;
        } else if (data[0] === "street") {
          address_data[data[1]].street = val;
        }

        this.setState({ address_data: address_data });
        return "";

      case "suscription_data":
        var suscription_data = this.state.suscription_data;
        var data = key.split(".");
        suscription_data[data[1]].suscription = val;
        this.setState({ suscription_data: suscription_data });
        return "";
    }
  };

  handleUpload(files) {
    this.setState({
      files: files
    });
  }

  handleNewComment(comment) {
    this.setState({ comment: comment });
  }

  handleCommentSubmit() {
    if (this.state.action !== "new") {
      var formData = new FormData();
      formData.set("comment", this.state.comment);
      let self = this;
      const token = localStorage.getItem("userToken");
      axios
        .post(api.subcontacts().comment(this.state.subcontact_id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ errors: false });
          self.setState({ dialogOpen: true, feature_deleted: true });
          self.setState({ message: "Comentario guardado con exito!" });
        })
        .catch(function(error) {
          self.setState({ errors: true });
          self.setState({ delete_address: false });
          self.setState({
            message:
              "No se pudo guardar tu comentario. Por favor volver a intentar"
          });
          self.setState({ dialogOpen: true });
        });
    } else {
      alert("Su comentario se agregará al guardar el proveedor");
    }
  }
  validateCuit = async () => {
    var cuit = this.state.basic_data.document_number;
    var cuitExists = false;
    var contact = await this.getApi(
      api.contacts().validateCuit(cuit, this.state.parent_contact_id)
    );
    if (contact) {
      if (contact[0]) {
        cuitExists = true;
      }
    }
    this.setState({ cuitExists: cuitExists });
  };

  validateEmail = async () => {
    var email = this.state.basic_data.email;
    var emailExists = false;
    var contact = await this.getApi(
      api.contacts().validateEmail(email, this.state.parent_contact_id)
    );
    if (contact) {
      if (contact[0]) {
        emailExists = true;
      }
    }
    this.setState({ emailExists: emailExists });
  };

  handleValidations() {
    var messages = {};
    var errorMessage = "";

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var isEmailValid = re.test(
      String(this.state.basic_data.email).toLowerCase()
    );

    if (
      this.state.basic_data.subcontact_type_id === 15 ||
      this.state.basic_data.subcontact_type_id === 16 ||
      this.state.basic_data.subcontact_type_id === 17
    ) {
      if (this.state.basic_data.phone === "") {
        errorMessage += "Debe completar el campo teléfono. ";
      }
    }

    messages.basic_data =
      this.state.basic_data.email !== "" &&
      isEmailValid &&
      this.state.basic_data.subcontact_type_id !== ""
        ? ""
        : errorMessage;

    var address_data_valid = true;

    /*    if (this.state.places.length === 0 ){
      messages.address_data = 'Debe ingresar al menos un domicilio.'
    } else {
      this.state.places.map((val, idx)=>{
        address_data_valid = (address_data_valid && (this.state.address_data[idx].code !=='' && this.state.address_data[idx].type !==''))
      })

      messages.address_data = (address_data_valid) ? '': 'Los domicilios deben tener un código y tipo de domicilio cargado.'
    }
*/
    if (this.state.cuitExists) {
      errorMessage += " El CUIT ya existe. ";
    }

    if (this.state.emailExists) {
      errorMessage += " El email ya existe. ";
    }

    if (errorMessage !== "") {
      messages.basic_data = errorMessage;
    }
    return messages.basic_data !== "";
  }

  handleSubmit = event => {
    this.setState({ backdrop: true });

    event.preventDefault();

    //    event.stopPropagation();
    if (this.handleValidations() === true) {
      this.setState({
        dialogOpen: true,
        message:
          "Hay errores en la carga o faltan carga campos. Por favor revisar",
        errors: true,
        errorMessage: "Debe cargar un domicilio",
        backdrop: false
      });
    } else {
      var formData = new FormData();
      var item = this.state;

      var item = this.state.basic_data;
      for (var key in item) {
        if (typeof item[key] != undefined && item[key] != null) {
          formData.set("contact[" + key + "]", item[key]);
          //console.log(key, item[key])
        }
      }
      formData.set(
        "subcontact[parent_contact_id]",
        this.state.parent_contact_id
      );
      formData.set("subcontact[firstname]", this.state.basic_data.firstname);
      formData.set("subcontact[lastname]", this.state.basic_data.lastname);
      formData.set(
        "subcontact[subcontact_type_id]",
        this.state.basic_data.subcontact_type_id
      );
      formData.set("subcontact[notes]", "");
      formData.set(
        "contact[document_number]",
        this.state.basic_data.document_number
          ? this.state.basic_data.document_number
          : ""
      );
      formData.set(
        "contact[document_type]",
        this.state.basic_data.document_type_id
      );
      formData.set(
        "contact[mobile]",
        this.state.basic_data.mobile ? this.state.basic_data.mobile : ""
      );
      formData.set(
        "contact[phone]",
        this.state.basic_data.phone ? this.state.basic_data.phone : ""
      );

      formData.set(
        "subcontact[code]",
        this.state.basic_data.code ? this.state.basic_data.code : ""
      );
      formData.set(
        "subcontact[contact_relation]",
        this.state.basic_data.contact_relation
          ? this.state.basic_data.contact_relation
          : ""
      );
      formData.set(
        "subcontact[license_number]",
        this.state.basic_data.license_number
      );
      formData.set(
        "subcontact[license_due_date]",
        this.state.basic_data.license_due_date
      );
      formData.set(
        "subcontact[client_structure_id]",
        this.state.basic_data.client_structure_id !== "" &&
          this.state.basic_data.client_structure_id !== null
          ? this.state.basic_data.client_structure_id
          : ""
      );
      formData.set(
        "subcontact[receive_invoice]",
        this.state.basic_data.receive_invoice ? 1 : 0
      );

      var suscription_idx = 0;
      this.state.suscription_data.map((val, idx) => {
        if (val.suscription_typ && val.suscription_type !== "") {
          formData.set(
            "subcontact[suscriptions][" + suscription_idx + "][suscription]",
            val.suscription ? val.suscription : "ESTADO DE CTA. CTE. CLIENTE"
          );
          suscription_idx++;
        }
      });

      this.state.items_to_delete.suscription.map((val, idx) => {
        if (val.suscription !== "" && val.suscription !== undefined) {
          formData.set(
            "subcontact[suscriptions][" + suscription_idx + "][suscription]",
            val.suscription
          );
          formData.set(
            "subcontact[suscriptions][" + suscription_idx + "][deleted_at]",
            new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " ")
          );
          suscription_idx++;
        }
      });

      var item = this.state.places;
      for (var key in item) {
        if (
          typeof item[key] != undefined &&
          item[key] != null &&
          item[key] !== ""
        ) {
          formData.set(
            "contact[address][" + key + "][code]",
            this.state.address_data[key].code
              ? this.state.address_data[key].code
              : "1"
          );
          formData.set(
            "contact[address][" + key + "][address_type_id]",
            this.state.address_data[key].type
              ? this.state.address_data[key].type
              : "1"
          );
          formData.set("contact[address][" + key + "][country_id]", 1); // address_component route 1
          //            formData.set("contact[address]["+key+"][street]", this.state.places[key][0].address_components[1].long_name); // address_component route 1
          formData.set(
            "contact[address][" + key + "][street]",
            this.state.places[key][0].address_components[1].short_name !== "AR"
              ? this.state.places[key][0].address_components[1].long_name
              : this.state.address_data[key].street
          ); // address_component route 1
          //            formData.set("contact[address]["+key+"][number]", this.state.places[key][0].address_components[0].long_name); // address_component street_number 0
          formData.set(
            "contact[address][" + key + "][number]",
            this.state.places[key][0].address_components[0].long_name === "S/N"
              ? this.state.address_data[key].street_number
              : this.state.places[key][0].address_components[0].long_name
          ); // address_component street_number 0

          formData.set(
            "contact[address][" + key + "][postal_code]",
            this.state.places[key][0].address_components[6]
              ? this.state.places[key][0].address_components[6].long_name
              : this.state.address_data[key].postal_code
          ); // address_component postal_code 6

          formData.set(
            "contact[address][" + key + "][province]",
            this.state.places[key][0].address_components[0].long_name === "S/N"
              ? this.state.places[key][0].address_components[3].long_name
              : this.state.places[key][0].address_components[4].long_name
          ); // address_component administrative_area_level_1 4
          formData.set(
            "contact[address][" + key + "][state]",
            this.state.places[key][0].address_components[0].long_name === "S/N"
              ? this.state.places[key][0].address_components[2].long_name
              : this.state.places[key][0].address_components[3].long_name
          ); // address_component administrative_area_level_1 4

          //            formData.set("contact[address]["+key+"][province]", this.state.places[key][0].address_components[4].long_name); // address_component administrative_area_level_1 4
          //            formData.set("contact[address]["+key+"][state]", this.state.places[key][0].address_components[3].long_name); // ??
          formData.set(
            "contact[address][" + key + "][lat]",
            this.state.address_data[key].id
              ? this.state.places[key][0].geometry.location.lat
              : this.state.places[key][0].geometry.location.lat()
          ); // this.state.places[key][0].geometry.location.lat()
          formData.set(
            "contact[address][" + key + "][long]",
            this.state.address_data[key].id
              ? this.state.places[key][0].geometry.location.lng
              : this.state.places[key][0].geometry.location.lng()
          ); // this.state.places[key][0].geometry.location.log()
          formData.set(
            "contact[address][" + key + "][data]",
            JSON.stringify(this.state.places[key][0])
          ); // this.state.places[key][0]

          formData.set(
            "contact[address][" + key + "][floor]",
            this.state.address_data[key].floor
              ? this.state.address_data[key].floor
              : ""
          );
          formData.set(
            "contact[address][" + key + "][departament]",
            this.state.address_data[key].departament
              ? this.state.address_data[key].departament
              : ""
          );
          formData.set(
            "contact[address][" + key + "][others]",
            this.state.address_data[key].others
              ? this.state.address_data[key].others
              : ""
          );
        }
        if (this.state.action === "edit" && this.state.address_data[key].id) {
          formData.set(
            "contact[address][" + key + "][id]",
            this.state.address_data[key].id
          );
        }
      }

      if (this.state.files) {
        this.state.files.map((val, idx) => {
          formData.set(`media[${idx}]`, val);
        });
      }

      if (this.state.comment !== "") {
        formData.set("comment", this.state.comment);
      }
      if (this.state.user && this.state.subcontact_id) {
        formData.set("subcontact[user_id]", this.state.basic_data.user_id);
      }
      let self = this;
      const token = localStorage.getItem("userToken");
      if (this.state.action === "new") {
        axios
          .post(api.subcontacts().post(), formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`
            }
          })
          .then(response => {
            self.setState({
              errors: false,
              save_subcontact: true,
              feature_deleted: false
            });
            self.setState({ message: "SubContacto creado con éxito!" });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          })
          .catch(function(error) {
            self.setState({
              errors: true,
              feature_deleted: false,
              save_subcontact: false
            });
            self.setState({
              message:
                "Hubo un problema al guardar el subcontacto. Por favor volver a intentar"
            });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          });
      } else {
        formData.set("contact[id]", this.state.contact_id);
        formData.append("_method", "patch");
        axios
          .post(api.subcontacts().patch(this.state.subcontact_id), formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`
            }
          })
          .then(response => {
            self.setState({
              errors: false,
              save_subcontact: true,
              feature_deleted: false
            });
            self.setState({ message: "SubContacto modificado con éxito!" });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          })
          .catch(function(error) {
            self.setState({
              errors: true,
              save_subcontact: false,
              feature_deleted: false
            });
            self.setState({
              message:
                "Hubo un problema al guardar el subcontacto. Por favor volver a intentar"
            });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          });
      }
    }
  };

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  render() {
    const handleRedirect = id => () => {
      window.location.href = "/subcontacts/" + this.state.parent_contact_id;
    };

    const handleDialogClose = () => {
      this.setState({ dialogOpen: false });
    };
    const disabled = this.state.disabled;
    const client_structures =
      this.state.contact.client !== null
        ? this.state.contact.client.structure
        : [];
    const business_name =
      this.state.contact.provider !== null
        ? this.state.contact.provider.business_name
        : this.state.contact.client.business_name;

    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header pt-4">
          <PageTitle
            sm="12"
            title={"SubContacto de " + business_name}
            className="text-sm-left"
          />
        </Row>
        <Row>
          <Col md="12">
            <React.Fragment>
              {this.state.dialogOpen ? (
                <Dialog
                  open={this.state.dialogOpen}
                  fullWidth
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"SubContacto"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>{this.state.message}</DialogContentText>
                  </DialogContent>
                  <DialogActions disableSpacing="false">
                    {this.state.delete_address ? (
                      <div>
                        <Button
                          onClick={this.handleDeleteAddress}
                          variant="contained"
                          color="primary"
                        >
                          Aceptar
                        </Button>
                        <Button
                          onClick={handleDialogClose}
                          variant="contained"
                          color="primary"
                        >
                          Cancelar
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}
                    {!this.state.errors && this.state.save_subcontact ? (
                      <Button
                        onClick={handleRedirect(this.state.parent_contact_id)}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}

                    {this.state.errors || this.state.feature_deleted ? (
                      <Button
                        onClick={handleDialogClose}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                  </DialogActions>
                </Dialog>
              ) : (
                ""
              )}
              {this.state.loading ? (
                <LinearProgress />
              ) : (
                <div>
                  <div className="row" className="mx-1">
                    <SubContactBasicDataComponent
                      disabled={disabled}
                      title="Datos básicos"
                      error={this.state.errorMessage}
                      onChange={this.handleChange}
                      basic_data={this.state.basic_data}
                      subcontact_types={this.state.subcontact_types}
                      document_types={this.state.document_types}
                      client_structures={client_structures}
                      isParentClient={this.state.contact.client ? true : false}
                      validateCuit={this.validateCuit}
                      cuitExists={this.state.cuitExists}
                      validateEmail={this.validateEmail}
                      emailExists={this.state.emailExists}
                    />
                  </div>
                  {this.state.user && this.state.user.id && (
                    <div className="row" className="mx-1">
                      <MobileData
                        disabled={disabled}
                        title="App Mobile"
                        onChange={this.handleChange}
                        basic_data={this.state.basic_data}
                        user={this.state.user}
                      />
                    </div>
                  )}
                  <div className="row" className="mx-1">
                    <AddressComponent
                      disabled={disabled}
                      error={""}
                      address_data={this.state.address_data}
                      places={this.state.places}
                      address_types={this.state.address_types}
                      title="Direcciones"
                      onDeleteMarks={this.deleteMarkS}
                      onRemoveItem={this.removeItem}
                      onPleaceSearch={this.handlePlaceSearch}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="row" className="mx-1">
                    <SubcontactSuscription
                      disabled={disabled}
                      suscription_data={this.state.suscription_data}
                      suscription_types={this.state.suscription_types}
                      title="Suscripciones"
                      onChange={this.handleChange}
                      addNewItem={this.addNewItem}
                      removeItem={this.filterItem}
                    />
                  </div>
                  <div>
                    <CommentsComponent
                      comments={this.state.comments}
                      onChange={this.handleNewComment}
                      onSubmit={this.handleCommentSubmit}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div>
                    <MediaComponent
                      media={this.state.media}
                      onChange={this.handleUpload}
                      disabled={this.state.disabled}
                    />
                  </div>
                  {this.state.action !== "view" ? (
                    <React.Fragment>
                      <Button
                        type="submit"
                        variant="contained"
                        className="mt-3 ml-1 mr-1"
                        color="primary"
                        onClick={e => this.handleSubmit(e)}
                      >
                        Guardar
                      </Button>
                      <Button
                        variant="contained"
                        className="mt-3 ml-1 mr-1"
                        color="secondary"
                        href={"/subcontacts/" + this.state.parent_contact_id}
                      >
                        Cancelar
                      </Button>
                    </React.Fragment>
                  ) : (
                    <Button
                      variant="contained"
                      className="mt-3 ml-1 mr-1"
                      color="secondary"
                      href={"/subcontacts/" + this.state.parent_contact_id}
                    >
                      Volver
                    </Button>
                  )}
                </div>
              )}
            </React.Fragment>
          </Col>
        </Row>
        <React.Fragment>
          <Backdrop
            open={this.state.backdrop}
            onClick={this.handleCloseBackdrop}
            style={{ zIndex: 10000, color: "#3f51b5" }}
          >
            <Typography className="ml-2" variant="h5" color="primary">
              Guardando...
            </Typography>
          </Backdrop>
        </React.Fragment>
      </Container>
    );
  }
}
export default SubContactForm;
